import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { getAiRolePlay } from 'redux/selectors/timeline';
import AiConversationContext from './context';

const ScenarioDetails = () => {
  const { aiRolePlayId } = useContext(AiConversationContext);
  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));

  return (
    <div className='d-flex flex-column mt-4 align-items-center'>
      <p className='text-large-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.THE_SCENARIO()}</p>
      <div className='mt-4'>
        <div>
          <p className='mb-0 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOUR_ROLE()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>You are a team lead who has noticed a decline in performance from one of your team members. You need to address this issue in a constructive manner.</p>
        </div>
        <div>
          <p className='mb-0 mt-4 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.THE_SITUATION()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>Jordan has been arriving 15-30 minutes late to work three times this week. These late arrivals are causing Jordan to miss the teams morning meetings, which is affecting team coordination and communication.</p>
        </div>
        <div>
          <p className='mb-0 mt-4 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOUR_GOAL()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>Practice having a direct but supportive conversation about attendance and expectations.</p>
        </div>
      </div>
    </div>
  );
};

export default ScenarioDetails;
